var defaultState = {
  baseUrl: window.SITE_CONFIG.BASE_URL,
  googleClientId: window.SITE_CONFIG.GOOGLE_CLIENT_ID,
  facebookAppId: window.SITE_CONFIG.FACEBOOK_APP_ID,
  stripePublishableKey: window.SITE_CONFIG.STRIPE_PUBLISHABLE_KEY,
  waitTimerId: null,
  fbInit: false,
  googleAuth2: null
}

export const getters = {
  baseUrl: state => state.baseUrl,
  googleClientId: state => state.googleClientId,
  facebookAppId: state => state.facebookAppId,
  stripePublishableKey: state => state.stripePublishableKey
}

export default {
  namespaced: true,
  state: defaultState,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js